export default () => !window.google_trackConversion
